/**
 * Backend user_tags values (UserSerializer BasicData / UserWithToken).
 * Only tags with active: true are included in API responses.
 */
export enum UserTag {
  ANALYST_CONTRACT = "analyst_contract",
  ANALYST_PURCHASE_ORDER = "analyst_purchase_order",
}

export function userHasActiveUserTag(user: { readonly user_tags?: readonly string[] | null }, tag: UserTag): boolean {
  return Array.isArray(user.user_tags) && user.user_tags.includes(tag);
}
